// 应用 code

export var APP_CODE = '';
export var setAppCode = function setAppCode(nextAppCode) {
  if (!nextAppCode) {
    return;
  }
  APP_CODE = nextAppCode;
};

// 平台 code

export var PLATFORM_CODE = '';
export var setPlatformCode = function setPlatformCode(nextPlatformCode) {
  if (!nextPlatformCode) {
    return;
  }
  PLATFORM_CODE = nextPlatformCode;
};

// 设定应用 & 平台 code
export var setChannel = function setChannel(options) {
  setAppCode(options.appCode);
  setPlatformCode(options.platformCode);
};
export var TOKEN_CACHE = 'token';
export var getAuthToken = function getAuthToken() {
  var _window;
  return (_window = window) === null || _window === void 0 || (_window = _window.localStorage) === null || _window === void 0 ? void 0 : _window.getItem(TOKEN_CACHE);
};
export var setAuthToken = function setAuthToken(value) {
  var _window2;
  return (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.localStorage) === null || _window2 === void 0 ? void 0 : _window2.setItem(TOKEN_CACHE, value);
};
export var removeAuthToken = function removeAuthToken() {
  var _window3;
  return (_window3 = window) === null || _window3 === void 0 || (_window3 = _window3.localStorage) === null || _window3 === void 0 ? void 0 : _window3.removeItem(TOKEN_CACHE);
};
export var getSaToken = getAuthToken;
export var getHeaders = function getHeaders() {
  return {
    appCode: APP_CODE,
    platformCode: PLATFORM_CODE,
    satoken: getAuthToken()
  };
};